import { render } from "./Logout.vue?vue&type=template&id=7fe128a6"
const script = {}

import exportComponent from "/opt/anthos/FBL_OTWS/OTWS_src5/otws-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__